import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { useProjectStore } from '@/stores/ProjectStore'
import { storeToRefs } from 'pinia'
import { whenever } from '@/utils/utils'

export const projectMemberGuard = ({ to }) => new Promise((resolve, reject) => {
  const { authUser } = storeToRefs(useAuthenticationStore())
  const { getProject } = useProjectStore()
  const { projectSlug, locale } = to.params

  const { project, error } = getProject({ id: projectSlug })

  whenever(project, () => authUser.value?.is_super_admin || authUser.value?.is_koalect || project.value.isAuthorized(authUser.value) ? resolve() : reject({ name: 'Project', params: { projectSlug, locale } }), { immediate: true, once: true })
  whenever(error, () => reject({ name: 'NotFound', params: { locale } }), { once: true })
})

export const projectSettingsGoalGuard = ({ to }) => new Promise((resolve, reject) => {
  const { getProject } = useProjectStore()
  const { projectSlug, locale } = to.params

  const { project } = getProject({ id: projectSlug })

  whenever(project, () => project.value.is_goal_allowed ? resolve() : reject({ name: 'PrivateSettingsGeneral', params: { projectSlug, locale } }), { immediate: true, once: true })
})

export const projectSettingsEventGuard = ({ to }) => new Promise((resolve, reject) => {
  const { getProject } = useProjectStore()
  const { projectSlug, locale } = to.params

  const { project } = getProject({ id: projectSlug })

  whenever(project, () => project.value.is_event_allowed ? resolve() : reject({ name: 'PrivateSettingsGeneral', params: { projectSlug, locale } }), { immediate: true, once: true })
})